import { Component, Input } from '@angular/core';
import { AnchorAction } from '../../../../models/action.model';

@Component({
    selector: 'sAnchorAction',
    templateUrl: './anchor-action.component.html',
    styleUrls: ['anchor-action.component.less'],
})
export class AnchorActionComponent {
    @Input() action: AnchorAction;

    downloadAttribute(): string {
        if (!this.action.download) return '';
        
        // Haal de bestandsnaam uit de URL
        const url = new URL(this.action.route, window.location.origin);
        const pathParts = url.pathname.split('/');
        return pathParts[pathParts.length - 1] || '';
    }
}
